import React, { useEffect, useState } from 'react';
import {
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { AccordionHeaderTitle } from 'component/Accordion';
import { pointGeometryToMapGeojson } from 'utils/Helper';
import { useMapGeojson } from 'hooks/useMapGeojson';
import { CommentDisplay } from 'component/CommentBlock';
import { useBufferZone } from 'hooks/useBufferZone';
import { useHAReports } from 'hooks/useHAReports';
import { HASwitchers } from 'component/HASwitchers';
import { Map } from '../../../component/Map';

export const MapInfo = (props) => {
  const [lmGeojson, setLmGeojson] = useState(props?.formData?.info?.lm?.geometry);
  const [bmGeojson, setBmGeojson] = useState(props?.formData?.info?.bm?.geometry);
  const fileZone = props?.formData?.info?.general?.file_zone ?? props?.formData?.file_zone;
  const evidenceGeojson = useMapGeojson(
    props?.formData?.info?.evidences?.evidence_geojson,
    fileZone,
  );

  const localHaReports = useHAReports(props?.map);
  const haReports = props?.haReports || localHaReports;
  useBufferZone(props?.map);

  useEffect(() => {
    if (props?.formData?.info?.lm?.geometry?.coordinates?.length) {
      setLmGeojson(
        pointGeometryToMapGeojson(
          props?.formData?.info?.lm?.geometry?.coordinates,
          fileZone
        )
      );
    }
  }, [props?.formData?.info?.lm?.geometry, fileZone]);

  useEffect(() => {
    if (props?.formData?.info?.bm?.geometry?.coordinates?.length) {
      setBmGeojson(
        pointGeometryToMapGeojson(
          props?.formData?.info?.bm?.geometry?.coordinates,
          fileZone
        )
      );
    }
  }, [props?.formData?.info?.bm?.geometry, fileZone]);

  return (
    <>
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId={props?.accordionId || '3'}
            titleUA="Мапа"
            titleEN="Map"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div style={{ position: 'relative' }}>
          <HASwitchers
            {...haReports}
            googleWms={true}
            style={{
              position: 'absolute',
              top: '66px',
              zIndex: 1,
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: '4px',
              padding: '0px 15px 7px 10px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              left: '0px',
              borderRadius: '0 0 8px',
              boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
            }}
          />

          <Map
            map={props?.map}
            setMap={props?.setMap}
            turnPointsPolygon={props?.formData?.info?.turn_points?.geojson}
            evidenceGeojson={evidenceGeojson}
            lmGeojson={lmGeojson}
            bmGeojson={bmGeojson}
            hazardAreaType={props?.formData?.info?.general?.hazard_area_type}
            evidences={props?.formData?.info?.evidences}
            haReportsPolygons={haReports?.haReportsPolygons}
            // azureLayerEnabled={haReports?.azureLayerEnabled}
            // setAzureLayerEnabled={haReports?.setAzureLayerEnabled}
            googleWms
          />
        </div>
        {props?.mode === 'check' && (
          <div style={{ marginTop: '10px' }}>
            <CommentDisplay comments={props?.comments} block="map" />
          </div>
        )}
      </AccordionItemPanel>
    </>
  );
};
